import { isAfter, isBefore } from 'date-fns';
export const isDateBetween = (date, start, end) => {
    return !isBefore(date, start) && !isAfter(date, end);
};
